import axios from "axios";

const baseUrl = process.env.REACT_APP_GITO_API_URL + "/charging-connectors/ChargingConnector";
//const baseUrl = "https://localhost:7241/ChargingConnector";

// Function to get all charging connectors
export async function getAllChargingConnectors(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-all-charging-connectors`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connectors"
        );
    }
}

export async function getAllChargingConnectorsSimplified(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-all-charging-connectors-simplified`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connectors"
        );
    }
}

export async function getChargingConnectorsSimplifiedByOperatorOrganizationPublicId(
    organizationPublicId,
    apiAccessToken
) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-charging-connectors-simplified-by-operator-organization-public-id/${organizationPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail ||
                "Failed to fetch charging connectors"
        );
    }
}



// Function to get a specific charging connector by chargingConnectorPublicId
export async function getChargingConnector(chargingConnectorPublicId, apiAccessToken) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-charging-connector/${chargingConnectorPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connector"
        );
    }
}

export async function getChargingConnectorByChargingPoint(chargingPointPublicId, apiAccessToken) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-charging-connectors/${chargingPointPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connector"
        );
    }
}

// Function to create a new charging connector
export async function createChargingConnector(chargingConnectorData, apiAccessToken) {
    try {
        const response = await axios.post(
            `${baseUrl}/create-charging-connector`,
            chargingConnectorData,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to create charging connector"
        );
    }
}

// Function to update an existing charging connector
export async function updateChargingConnector(chargingConnectorData, apiAccessToken) {
    try {
        console.log("Charging connector data being sent to API:", chargingConnectorData);

        const response = await axios.put(
            `${baseUrl}/update-charging-connector`,
            chargingConnectorData,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update charging connector"
        );
    }
}

// Function to delete a charging connector by chargingConnectorPublicId
export async function deleteChargingConnector(chargingConnectorPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(
            `${baseUrl}/delete-charging-connector/${chargingConnectorPublicId}`,
            {
                headers: {
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to delete charging connector"
        );
    }
}


export async function getConnectorStandards(apiAccessToken) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-connector-standards`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connector"
        );
    }
}


export async function getsimplechargingconnectors(apiAccessToken) {
    try {
        const response = await axios.get(
            `${baseUrl}/get-simple-charging-connectors`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging connector"

        )}
}

export async function get_transaction_by_ConnectorPublicId(apiAccessToken, connectorPublicId) {
    try {
        const response = await axios.get(`${baseUrl}/get-transaction-by-ConnectorPublicId/${connectorPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail
            || 'Failed to call GET /get-transaction_by_ConnectorPublicId'

        );
    }
}

export async function getCurrentReservationByConnectorPublicId(apiAccessToken, chargingConnectorPublicId) {
    try {
        const response = await axios.get(`${baseUrl}/get-current-reservation/${chargingConnectorPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });

        // Backend returns 204 when no reservation exists
        if (response.status === 204) {
            return null;
        }

        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) {
            return null;
        }

        throw new Error(
            error.response?.data?.detail
            || "Failed to fetch current reservation"
        );
    }
}
